import React, { useEffect, useState } from 'react';

const UpgradeBanner = () => {
    const handleScrolling = () => {
        const element = document.getElementById("available-plans-section");
        const timer = setTimeout(() => {
            element?.scrollIntoView({ behavior: "smooth", block: "center"});
            window.history.replaceState({}, document.title);
        }, 100)
    };

    return (
      <div className="bg-dark-600 rounded-2xl p-6 mb-8 relative overflow-hidden pro-glow transform-gpu hover:-translate-y-1 hover:shadow-lg transition-medium">
        <div className="absolute top-0 right-0 w-96 h-96 opacity-10">
          <i className="fas fa-crown text-accent-pink animate-spin" style={{ fontSize: '24rem', transform: 'translate(25%, -25%) rotate(15deg)' }}></i>
        </div>
        
        {/* Floating particles */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="particle-1"></div>
          <div className="particle-2"></div>
          <div className="particle-3"></div>
        </div>
        
        <div className="flex flex-col md:flex-row items-center justify-between z-10 relative">
          <div className="mb-4 md:mb-0 group">
            <h3 className="text-xl font-bold gradient-text-pro mb-2 group-hover:animate-pulse-text">Unlock Advanced Hacking Tools</h3>
            <p className="text-gray-300 mb-4 max-w-lg group-hover:text-white transition-medium">
              Upgrade to Professional plan to access all server testing tools and advanced hacking methods for maximum success rate.
            </p>
            <button onClick={handleScrolling} className="bg-gradient-to-r from-accent-pink to-accent-orange text-white px-6 py-2.5 rounded-xl hover:opacity-90 transition font-medium transform-gpu hover:-translate-y-0.5 hover:shadow-glow-pink active:translate-y-0 active:shadow-inner flex items-center">
              <i className="fas fa-crown mr-2 group-hover:animate-spin transition-medium"></i> Upgrade to Professional
            </button>
          </div>
          
          <div className="w-32 h-32 flex items-center justify-center animate-float transform-gpu group-hover:scale-110 transition-medium">
            <i className="fas fa-lock-open text-5xl text-accent-pink opacity-70"></i>
          </div>
        </div>
      </div>
    );
  };

export default UpgradeBanner;